module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "d12e29"
    }
  }, [_vm._v("Praise for Denise Hunter’s Novels")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d12e31"
    }
  }, [_vm._v("“. . . [S]ure to grab readers by the heart.”")]), _vm._v(" "), _c('p', {
    staticClass: "txR",
    attrs: {
      "id": "d12e33"
    }
  }, [_vm._v("—"), _c('i', [_vm._v("Publishers Weekly ")]), _vm._v("review of "), _c('i', [_vm._v("Sweetwater Gap")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d12e40"
    }
  }, [_vm._v("“Oh my! Denise Hunter knows how to write! "), _c('i', [_vm._v("A Convenient Groom ")]), _vm._v("is a love story overflowing with emotion, tenderness and attraction that captivated me from beginning to end . . . I can’t recommend this book highly enough - for its beautiful love story and the stunning allegory of God’s unconditional and sacrificial love. "), _c('i', [_vm._v("A Convenient Groom ")]), _vm._v("is a must read.”")]), _vm._v(" "), _c('p', {
    staticClass: "txr",
    attrs: {
      "id": "d12e48"
    }
  }, [_vm._v("—RelzReviewz")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d12e50"
    }
  }, [_vm._v("“. . . a romantic adventure about unconditional love and forgiveness.”")]), _vm._v(" "), _c('p', {
    staticClass: "txr",
    attrs: {
      "id": "d12e52"
    }
  }, [_vm._v("—"), _c('i', [_vm._v("Library Journal ")]), _vm._v("review of "), _c('i', [_vm._v("Surrender Bay")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d12e59"
    }
  }, [_vm._v("“Hunter’s characters are well drawn and familiar. [W]ill appeal to all women readers with the taste for a good love story.”")]), _vm._v(" "), _c('p', {
    staticClass: "txr",
    attrs: {
      "id": "d12e61"
    }
  }, [_vm._v("—"), _c('i', [_vm._v("Foreword ")]), _vm._v("magazine review of "), _c('i', [_vm._v("Surrender Bay")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d12e68"
    }
  }, [_vm._v("“No one can write a story that grips the heart like Denise Hunter. If you like Karen Kingsbury or Nicholas Sparks, this is an author you’ll love.” ")]), _vm._v(" "), _c('p', {
    staticClass: "txr",
    attrs: {
      "id": "d12e70"
    }
  }, [_vm._v("—Colleen Coble, author of "), _c('i', [_vm._v("Lonestar Sanctuary")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d12e75"
    }
  }, [_vm._v("“Denise Hunter skillfully paints a story of desperate choices with dire consequences.”")]), _vm._v(" "), _c('p', {
    staticClass: "txr",
    attrs: {
      "id": "d12e77"
    }
  }, [_vm._v("—Diann Hunt, author of "), _c('i', [_vm._v("Hot Flashes and Cold Cream")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d12e81"
    }
  }, [_vm._v("“In "), _c('i', [_vm._v("Finding Faith ")]), _vm._v("Denise Hunter once again brings me to tears with her thought-provoking story. For depth and emotion, this author always hits her mark.”")]), _vm._v(" "), _c('p', {
    staticClass: "txr",
    attrs: {
      "id": "d12e86"
    }
  }, [_vm._v("—Kristin Billerbeck, author of "), _c('i', [_vm._v("Split Ends")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68e61c4e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hunt_9781595542595_epub_c2_r1.vue
// module id = 57
// module chunks = 0